export enum EditModes {
  CREATE,
  EDIT,
  CREATE_OR_EDIT
}
